import React from 'react'

const SendIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42" height="42" viewBox="0 0 60 60" {...props}>
    <circle cx="30" cy="30" r="30" fill="#78BE20" />
    <g clipPath="url(#clip0)">
      <path
        d="M32.188 30.5H25.438"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.114 40.338a.85.85 0 0 0 .207.933c.132.112.294.181.466.197.171.016.344-.021.494-.106l17.719-10.134a.85.85 0 0 0 0-1.476L23.32 19.643a.85.85 0 0 0-1.226.52c-.045.166-.038.341.02.503l3.323 9.834-3.323 9.838Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="27" height="27" fill="#fff" transform="translate(17 17)" />
      </clipPath>
    </defs>
  </svg>
)

export default SendIcon
